import type { EventTeam } from '@/lib/api/alertEvents';

/**
 * 2026 home schedule at Hard Rock Stadium, as published by the teams
 * (miamidolphins.com 2026 schedule release, miamihurricanes.com schedule page).
 *
 * Kickoffs carry an explicit UTC offset so the seeded instants are correct
 * regardless of the browser timezone (EDT −04:00 until Nov 1, EST −05:00 after).
 * Dolphins weeks 5-17 are subject to NFL flexible scheduling; Hurricanes games
 * still listed TBA get the whole game day covered until a time is set.
 */
export type SeasonGame = {
  id: string;
  team: EventTeam;
  opponent: string;
  /** ISO 8601 with explicit offset. For TBA games the time is a placeholder. */
  kickoff: string;
  timeTbd: boolean;
  note?: string;
};

export const SEASON_2026: SeasonGame[] = [
  // ---- Miami Dolphins (preseason) ----
  {
    id: 'dolphins-2026-08-22',
    team: 'DOLPHINS',
    opponent: 'New York Giants',
    kickoff: '2026-08-22T16:00:00-04:00',
    timeTbd: false,
    note: 'Preseason',
  },
  {
    id: 'dolphins-2026-08-28',
    team: 'DOLPHINS',
    opponent: 'Atlanta Falcons',
    kickoff: '2026-08-28T19:00:00-04:00',
    timeTbd: false,
    note: 'Preseason',
  },
  // ---- Miami Dolphins (regular season) ----
  {
    id: 'dolphins-2026-09-27',
    team: 'DOLPHINS',
    opponent: 'Kansas City Chiefs',
    kickoff: '2026-09-27T13:00:00-04:00',
    timeTbd: false,
    note: 'Week 3 · home opener',
  },
  {
    id: 'dolphins-2026-10-11',
    team: 'DOLPHINS',
    opponent: 'Cincinnati Bengals',
    kickoff: '2026-10-11T13:00:00-04:00',
    timeTbd: false,
    note: 'Week 5 · flex',
  },
  {
    id: 'dolphins-2026-11-01',
    team: 'DOLPHINS',
    opponent: 'New England Patriots',
    kickoff: '2026-11-01T16:25:00-05:00',
    timeTbd: false,
    note: 'Week 8 · flex',
  },
  {
    id: 'dolphins-2026-11-08',
    team: 'DOLPHINS',
    opponent: 'Detroit Lions',
    kickoff: '2026-11-08T13:00:00-05:00',
    timeTbd: false,
    note: 'Week 9 · flex',
  },
  {
    id: 'dolphins-2026-11-29',
    team: 'DOLPHINS',
    opponent: 'New York Jets',
    kickoff: '2026-11-29T13:00:00-05:00',
    timeTbd: false,
    note: 'Week 12 · flex',
  },
  {
    id: 'dolphins-2026-12-13',
    team: 'DOLPHINS',
    opponent: 'Chicago Bears',
    kickoff: '2026-12-13T13:00:00-05:00',
    timeTbd: false,
    note: 'Week 14 · flex',
  },
  {
    id: 'dolphins-2026-12-27',
    team: 'DOLPHINS',
    opponent: 'Los Angeles Chargers',
    kickoff: '2026-12-27T13:00:00-05:00',
    timeTbd: false,
    note: 'Week 16 · flex',
  },
  {
    id: 'dolphins-2027-01-03',
    team: 'DOLPHINS',
    opponent: 'Buffalo Bills',
    kickoff: '2027-01-03T13:00:00-05:00',
    timeTbd: false,
    note: 'Week 17 · flex',
  },
  // ---- Miami Hurricanes (home games) ----
  {
    id: 'hurricanes-2026-09-10',
    team: 'HURRICANES',
    opponent: 'Florida A&M',
    kickoff: '2026-09-10T20:00:00-04:00',
    timeTbd: false,
    note: 'Home opener',
  },
  {
    id: 'hurricanes-2026-09-26',
    team: 'HURRICANES',
    opponent: 'Central Michigan',
    kickoff: '2026-09-26T18:30:00-04:00',
    timeTbd: false,
    note: 'Family Weekend',
  },
  {
    id: 'hurricanes-2026-10-17',
    team: 'HURRICANES',
    opponent: 'Florida State',
    kickoff: '2026-10-17T15:30:00-04:00',
    timeTbd: true,
    note: 'Orange Out · time TBA',
  },
  {
    id: 'hurricanes-2026-10-24',
    team: 'HURRICANES',
    opponent: 'Pittsburgh',
    kickoff: '2026-10-24T15:30:00-04:00',
    timeTbd: true,
    note: 'Time TBA',
  },
  {
    id: 'hurricanes-2026-11-14',
    team: 'HURRICANES',
    opponent: 'Duke',
    kickoff: '2026-11-14T15:30:00-05:00',
    timeTbd: true,
    note: 'Homecoming · time TBA',
  },
  {
    id: 'hurricanes-2026-11-21',
    team: 'HURRICANES',
    opponent: 'Virginia Tech',
    kickoff: '2026-11-21T15:30:00-05:00',
    timeTbd: true,
    note: 'Salute to Service · time TBA',
  },
  {
    id: 'hurricanes-2026-11-28',
    team: 'HURRICANES',
    opponent: 'Boston College',
    kickoff: '2026-11-28T15:30:00-05:00',
    timeTbd: true,
    note: 'Time TBA',
  },
];
